export class Email {
  public _id:String;
  public mail: String;
  constructor(){}
}
